export enum ResourceErrorType {
    HTTP_BAD_REQUEST_ERROR = "HTTP_BAD_REQUEST_ERROR",
    HTTP_UNAUTHORIZED_ERROR = "HTTP_UNAUTHORIZED_ERROR",
    HTTP_FORBIDDEN_ERROR = "HTTP_FORBIDDEN_ERROR",
    HTTP_NOT_FOUND_ERROR = "HTTP_NOT_FOUND_ERROR",
    HTTP_SERVER_ERROR = "HTTP_SERVER_ERROR",
    HTTP_OTHER_ERROR = "HTTP_OTHER_ERROR",
    COGNITO_ERROR = "COGNITO_ERROR",
    UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

export enum CognitoErrorReason {
    EMAIL_NOT_CONFIRMED = "EMAIL_NOT_VALIDATED",
    UNKNOWN = "UNKNOWN",
}

interface AbstractResourceError<Type extends ResourceErrorType> {
    type: Type;
    message: string;
}

export type HttpError = AbstractResourceError<
    | ResourceErrorType.HTTP_BAD_REQUEST_ERROR
    | ResourceErrorType.HTTP_UNAUTHORIZED_ERROR
    | ResourceErrorType.HTTP_FORBIDDEN_ERROR
    | ResourceErrorType.HTTP_NOT_FOUND_ERROR
    | ResourceErrorType.HTTP_SERVER_ERROR
    | ResourceErrorType.HTTP_OTHER_ERROR
>;

export type CognitoError = AbstractResourceError<ResourceErrorType.COGNITO_ERROR> & {
    reason: CognitoErrorReason;
};

export type UnknownError = AbstractResourceError<ResourceErrorType.UNKNOWN_ERROR>;

export type ResourceError = HttpError | CognitoError | UnknownError;

export class ResourceException extends Error {
    resourceError: ResourceError;

    constructor(resourceError: ResourceError, ...params: (string | undefined)[]) {
        super(...params);

        this.resourceError = resourceError;
        this.name = "ResourceException";
    }
}
